var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-list-management',{ref:"baseListManagement",attrs:{"configData":_vm.configData}})
}
var staticRenderFns = []

export { render, staticRenderFns }